/**
 * Created by lihanying on 2017/10/24.
 */
import React from 'react'
import { ContactsOutlined, IdcardOutlined } from '@ant-design/icons'
import { Modal, Input, Tabs } from 'antd'
const TabPane = Tabs.TabPane

export default class extends React.Component {
  state = {
    cost_income: '0',
    qty_income: '',
    qty_outcome: '',
    type: '1'
  };

  onTabClick = (value) => {
    this.setState({ type: value })
  };

  render() {
    const { modalSpeed, record, inStorage } = this.props
    return (
      <div>
        <Modal
          title={record.commodity_name}
          visible={modalSpeed}
          onOk={() => this.props.handleOk({
            commodity_id: record.id,
            cost_income: this.state.cost_income * 100,
            qty_income: this.state.qty_income,
            qty_outcome: this.state.qty_outcome,
            type: this.state.type,
          })}
          onCancel={this.props.handleCancel}
          width="600px"
        >
          <Tabs defaultActiveKey="1" onTabClick={this.onTabClick}>
            <TabPane tab={<span><IdcardOutlined />入库</span>} key="1">
              <div className="diamond-item">
                <span>现有库存</span>
                <h3 style={{ marginLeft: '1rem' }}>{inStorage.qty_balance}</h3>
              </div>
              <div className="diamond-item">
                <span className="diamond-span">入库数量</span>
                <Input size="large" style={{ width: '60%', marginLeft: '1rem' }} placeholder="请输入入库的数量"
                  onChange={(e) => this.setState({ qty_income: e.target.value })} />
              </div>
              <div className="diamond-item">
                <span className="diamond-span">成本单价</span>
                <Input size="large" style={{ width: '60%', marginLeft: '1rem' }} placeholder="请输入商品成本单价,不填默认零"
                  onChange={(e) => this.setState({ cost_income: e.target.value })} />
              </div>
            </TabPane>
            <TabPane tab={<span><ContactsOutlined />退库</span>} key="2">
              <div className="diamond-item">
                <span>现有库存</span>
                <h3 style={{ marginLeft: '1rem' }}>{inStorage.qty_balance}</h3>
              </div>
              <div className="diamond-item">
                <span className="diamond-span" style={{ color: 'red' }}>退库数量</span>
                <Input size="large" style={{ width: '60%', marginLeft: '1rem', borderColor: 'red' }} placeholder="请输入退库的数量"
                  onChange={(e) => this.setState({ qty_outcome: e.target.value })} />
              </div>
              <div className="diamond-item">
                <span className="diamond-span" style={{ color: '#d6c6c6' }}>成本单价</span>
                <Input size="large" style={{ width: '60%', marginLeft: '1rem' }} disabled={true} value={record.commodity_price + '元'} />
              </div>
            </TabPane>
          </Tabs>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubCommodity/component/modalSpeed.js